export default __webpack_public_path__ + "static/media/icon-succeed.bd99f1de.svg";